import React, {Fragment} from 'react';
import PropTypes from 'prop-types';
import styles from '../Modal.module.scss';

const ModalContent = ({title, message, buttons, children, ...props}) => {

    const preventClickPropagation = (event) => {
        event.stopPropagation();
    };

    const content = children ? children : (
        <Fragment>
            <div className={styles.modalContentIconContainer}>
                {title}
            </div>
            <div className={styles.modalContentMessageContainer}>
                {message}
            </div>
            <div className={styles.modalContentButtonsContainer}>
                {buttons}
            </div>
        </Fragment>
    );

    return (
        <div className={styles.modalContentContainer} onClick={preventClickPropagation} {...props}>
            {content}
        </div>
    );
};

ModalContent.propTypes = {
    title: PropTypes.any,
    message: PropTypes.any,
    children: PropTypes.any,
    buttons: PropTypes.any,
};

ModalContent.defaultProps = {
    title: null,
    message: null,
    children: null,
    buttons: null,
};

export default ModalContent;
